import nationalPorts from "../data/national_ports.json";
import balearesPorts from "../data/baleares_ports.json";
import canaryPorts from "../data/canary_ports.json";

export const isNational = (portCode) => {
  return nationalPorts.includes(portCode);
};

export const isBaleares = (portCode) => {
  return balearesPorts.includes(portCode);
};

export const isCanary = (portCode) => {
  return canaryPorts.includes(portCode);
};
